/* Bikeparts: menu link fixes (applied in the browser, menus themselves untouched)
   1. Brand A–Z / 0–9 menu items point to the home page in the menu admin.
      Send them to the matching letter on the Shop by Brand page instead.
   2. Point old Shimano / SRAM / Pirelli brand pages to the new brand landing pages.
   3. Hide menu links to brand collections with no in-stock products (updates automatically). */
(function () {
  // Filled in by the theme: brand collections in the menu with no in-stock products
  var EMPTY_BRAND_COLLECTIONS = (window.bpHiddenBrandLinks || []).filter(Boolean);
  function fix(root) {
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      var path = href.replace(/^https?:\/\/[^\/]+/, '');
      var text = (a.textContent || '').trim();
      if ((path === '/' || path === '') && (/^[A-Z]$/.test(text) || text === '0-9')) {
        a.setAttribute('href', '/pages/shop-by-brand#brands-' + text.toLowerCase());
        continue;
      }
      var BRAND_PAGE_REDIRECTS = { '/pages/shimano-collection': '/collections/shimano', '/pages/sram-collection': '/collections/sram', '/pages/pirelli': '/collections/pirelli' };
      var clean = path.split('?')[0].split('#')[0];
      if (BRAND_PAGE_REDIRECTS[clean]) { a.setAttribute('href', BRAND_PAGE_REDIRECTS[clean]); continue; }
      for (var j = 0; j < EMPTY_BRAND_COLLECTIONS.length; j++) {
        if (path.split('?')[0] === EMPTY_BRAND_COLLECTIONS[j]) {
          var li = a.closest('li');
          (li || a).style.display = 'none';
        }
      }
    }
  }
  if (document.readyState !== 'loading') fix(document);
  else document.addEventListener('DOMContentLoaded', function () { fix(document); });
})();
